// extracted by mini-css-extract-plugin
module.exports = {"BLOCK":"HeaderTitle_BLOCK__3EVjw","headerIcon":"HeaderTitle_headerIcon__2cVXm"};